
import { combineReducers } from 'redux';

import project from './project';

export {
    getDataProjectId,
    getMapDataMapping,
    getMapLayerByAttachedDataModel,
    getMapLayerById,
    getMapLayers,
    getReportProjectId,
    getSearchProjectId
} from './project';

export default combineReducers({
    project,
});
